<template>
  <PrintPage :pageNumber="pageNumber">
    <template v-slot:header>
      <slot>
        <PrintHeaderSSPSlim />
      </slot>
    </template>
    <div class="content-box">
      <div class="content-box-header">
        <h2>7. {{ $t('hak') }}</h2>
      </div>
      <div class="two-column-grid"></div>
    </div>
    <AttachmentsPrintGrid
      :attachments="project.openHAKAttachments"
      fieldName="openHAKAttachments"
      :maxImages="2"
    />

    <AttachmentsPrintGrid
      :attachments="project.closedHAKWithSealAttachments"
      fieldName="closedHAKWithSealAttachments"
      :maxImages="2"
    />
  </PrintPage>
</template>

<script>
import PrintPage from '@/components/Print/PrintPage';
import PrintHeaderSSPSlim from '@/components/Print/PrintHeaderSSPSlim';
import AttachmentsPrintGrid from '@/components/Print/AttachmentsPrintGrid';
import { range } from '@/helpers/math.js';

export default {
  name: 'MeasurementPrintPage1',
  components: {
    PrintPage,
    PrintHeaderSSPSlim,
    AttachmentsPrintGrid,
  },
  props: {
    project: null,
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },
  computed: {},
  methods: { range },
};
</script>
